import appConfig from '@/config/appConfig.typed';

import {injectGoogleTagManagerScript} from './injectGoogleTagManager';

type WindowWithDataLayer = Window & {dataLayer?: unknown[]};

export const ensureGoogleTagManagerInjected = (): void => {
    const googleTagManagerId = appConfig.getGoogleTagManagerId();

    if (!googleTagManagerId) return;

    const w = window as WindowWithDataLayer;

    w.dataLayer = w.dataLayer || [];
    injectGoogleTagManagerScript(googleTagManagerId);
};
